import styled from "styled-components";
import dayjs from "dayjs";
import { Modal } from "@/components/renderbus-modal";
import { ModalProps } from "antd";
import { useTranslation } from "react-i18next";
import { IUserNameRecord } from "@/pages/profile/types/modify-name";

export function ViewRecordModal({
  modalProps,
  data = [],
}: {
  modalProps?: ModalProps;
  data?: IUserNameRecord[];
}) {
  const { t } = useTranslation("profile");
  return (
    <Modal {...modalProps}>
      <InfoTable>
        <tr>
          <th>{t("account_login_record_header_times")}</th>
          <th>{t("account_login_record_header_before")}</th>
          <th>{t("account_login_record_header_after")}</th>
          <th>{t("account_login_record_header_date")}</th>
        </tr>
        {data &&
          Boolean(data.length) &&
          data.map((item, index: number) => (
            <tr>
              <td>{data.length - index}</td>
              <td>{item.beforeUserName}</td>
              <td>{item.afterUserName}</td>
              <td>{dayjs(item.changeDate).format("YYYY-MM-DD HH:mm:ss")}</td>
              {/* <td>{new Date(item.changeDate)。}</td> */}
            </tr>
          ))}
      </InfoTable>
    </Modal>
  );
}

const InfoTable = styled.table`
  width: 100%;
  margin-top: -8px;
  tr {
    display: flex;
    width: 100%;
    justify-content: space-between;
    *:first-child {
      padding-left: 24px;
    }
  }
  th,
  td {
    flex: 1;
    text-align: start;
    background: #222327;
    color: #636770;
    font-size: 12px;
    height: 36px;
    line-height: 36px;
  }
  td {
    background: transparent;
    color: #d9dfe0;
  }
  tr {
    border-bottom: 1px solid #4c4e53;
    &:first-child {
      border: none;
    }
  }
`;
